export const tipoTextoPadraoTypes = {
  ACOMPANHAMENTO: { value: 'ACOMPANHAMENTO', key: 1 },
  CONSULTACLIENTES: { value: 'CONSULTACLIENTES', key: 2 },
  CONTACORRENTE: { value: 'CONTACORRENTE', key: 3 },
  DEVOLUCAO: { value: 'DEVOLUCAO', key: 4 },
  RELATORIO: { value: 'RELATORIO', key: 5 },
};
